export function parseLiveInfo(data) {
    const liveTournaments = new Set(Object.keys(data.tnl));

    const liveSports = new Set();
    const liveCategories = new Set();
    liveTournaments.forEach(id => {
        const parts = id.split('_');
        const [sportId, categoryId] = [parseInt(parts[0], 10), parts[1]];
        const categoryFullId = `${sportId}_${categoryId}`;
        liveSports.add(sportId);
        liveCategories.add(categoryFullId);
    });

    return {
        eventsCount: data.nel,
        liveSports,
        liveCategories,
        liveTournaments
    };
}
